import api from './api';

const equipoService = {
  getEquipos: async (params = {}) => {
    try {
      const response = await api.get('/api/equipos', { params });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener equipos';
    }
  },

  getEquipo: async (equipoId) => {
    try {
      const response = await api.get(`/api/equipos/${equipoId}`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener equipo';
    }
  },

  verificarEquipo: async (numeroSerie) => {
    try {
      const response = await api.get(`/api/equipos/verificar/${numeroSerie}`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al verificar equipo';
    }
  },

  updateEmbarcacion: async (equipoId, embarcacion, ubicacion = null) => {
    try {
      const params = new URLSearchParams();
      params.append('embarcacion', embarcacion);
      if (ubicacion) params.append('ubicacion', ubicacion);
      
      const response = await api.put(`/api/equipos/${equipoId}/embarcacion?${params.toString()}`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al actualizar embarcación';
    }
  },

  createEquipo: async (equipoData) => {
    try {
      const response = await api.post('/api/equipos', equipoData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al crear equipo';
    }
  },

  updateEquipo: async (equipoId, equipoData) => {
    try {
      const response = await api.put(`/api/equipos/${equipoId}`, equipoData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al actualizar equipo';
    }
  },

  cambiarEstado: async (equipoId, nuevoEstado, motivo = null) => {
    try {
      const response = await api.post(`/api/equipos/${equipoId}/cambiar-estado`, {
        nuevo_estado: nuevoEstado,
        motivo: motivo
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al cambiar estado del equipo';
    }
  },

  deleteEquipo: async (equipoId) => {
    try {
      await api.delete(`/api/equipos/${equipoId}`);
      return true;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al eliminar equipo';
    }
  },

  getHistorialEquipo: async (equipoId) => {
    try {
      const response = await api.get(`/api/equipos/${equipoId}/historial`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener historial del equipo';
    }
  }
};

export default equipoService;